import React from "react";

import AppLink from "../../AppLink";
import AccountActions from "./AccountActions";
import NotificationsMenu from "./NotificationsMenu";
import HeartIcon from "../../Icons/Heart";
import { NotificationsProvider } from "../../../contexts/Notifications/context";

import colors from "../../../utils/colorConstants";

const HeaderAccountSectionLoggedIn = () => (
  <NotificationsProvider>
    <div className="flex items-center justify-end w-full">
      <AccountActions />

      <div className="inline-block w-px h-3 mx-4 bg-alto" />

      <div className="inline-flex flex-none">
        <div className="flex inline-flex leading-4 space-x-4">
          <AppLink
            href="/cards/favorites"
            tracking={{
              block_name: "masthead",
              block_row: "masthead",
              id: "header_favorites",
            }}
            shallow
          >
            <HeartIcon width="1.5rem" height="1.5rem" stroke={colors.lapel} />
          </AppLink>

          <NotificationsMenu />
        </div>
      </div>
    </div>
  </NotificationsProvider>
);

export default HeaderAccountSectionLoggedIn;
